<template>
  <Filters
    :initialFilter="initialFilter"
    :filterStates="filterStates"
    :customFilterStates="customFilterStates"
    :disabledFilters="defaultFilterTypes"
    :filters="[
      {
        type: FilterType.LINKED_TO,
        props: {
          filterSitesFn: (site) =>
            hasPermission(permissions.readDocument, site.id),
        },
      },
      { type: FilterType.EXPIRATION_DATE },
      { type: FilterType.NOTIFICATION_DATE },
      { type: FilterType.VISIBILITY },
      { type: FilterType.TAGS },
    ]"
    @apply="handleApplyFilter"
    @clear="handleClearFilters"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
  </Filters>
</template>

<script setup>
import { inject } from "vue";
import { storeToRefs } from "pinia";
import { Filters, FilterType } from "@/Components/Filters";
import { useFilters } from "@/Composables/useFilters";

defineProps({
  initialFilter: { type: String, required: false },
});

const { hasPermission, permissions } = inject("permissions");

const filterStore = useFilters("files");
const { filterStates, customFilterStates, defaultFilterTypes } =
  storeToRefs(filterStore);
const { handleChangeFilter, handleClearFilters } = filterStore;

function handleApplyFilter({ filterType, filterState }) {
  handleChangeFilter(filterType, filterState);
}
</script>
